import { ErrorBoundary } from '@bechtel/client-common';
import { Alert, Spinner, SpinnerSize, Text } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { map } from 'lodash';
import { Suspense, useState } from 'react';
import { useProjectAdminTabPermissions } from '~/hooks/use-project-permissions';
import {
  ProjectAdminContainerStyled,
  ProjectAdminHeaderStyled,
  ProjectAdminTabStyled,
  TabButtonStyled,
} from '../styled';
import { ImportUsers } from './import';
import { ManagePermissions } from './permissions';
import { ManageRoles } from './roles';
import { UserAdminTabList } from './tab-data';
import { UserAdminTab, UserAdminTabType } from './types';
import { ManageUsers } from './users';

export const UserAdmin = () => {
  const [selectedTab, setSelectedTab] = useState<UserAdminTabType>(UserAdminTabType.EDIT_USERS);
  const { i18n } = useLingui();
  const { canManageUserAdminFully } = useProjectAdminTabPermissions();
  return (
    <ProjectAdminContainerStyled>
      <ProjectAdminHeaderStyled>
        <Text family="graphik" size="600" weight="600" color="white">
          <Trans>User Admin</Trans>
        </Text>
      </ProjectAdminHeaderStyled>
      <ProjectAdminTabStyled>
        {map(UserAdminTabList, (tabItem: UserAdminTab) => {
          return (
            <TabButtonStyled
              selected={tabItem.value === selectedTab}
              onClick={() => {
                setSelectedTab(tabItem.value);
              }}
              key={tabItem.value}
            >
              {i18n._(tabItem.label)}
            </TabButtonStyled>
          );
        })}
      </ProjectAdminTabStyled>
      {selectedTab == UserAdminTabType.EDIT_USERS && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <ManageUsers />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == UserAdminTabType.CUSTOMIZE_ROLES && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            {canManageUserAdminFully ? (
              <ManageRoles />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to customize roles.</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == UserAdminTabType.CHANGE_PERMISSIONS && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            {canManageUserAdminFully ? (
              <ManagePermissions />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to change permissions.</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == UserAdminTabType.IMPORT_DEFAULT_USERS && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            {canManageUserAdminFully ? (
              <ImportUsers />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to import default users.</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
    </ProjectAdminContainerStyled>
  );
};
